import { render, staticRenderFns } from "./order-payment.vue?vue&type=template&id=4672b988&scoped=true"
import script from "./order-payment.vue?vue&type=script&lang=js"
export * from "./order-payment.vue?vue&type=script&lang=js"
import style0 from "./order-payment.vue?vue&type=style&index=0&id=4672b988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4672b988",
  null
  
)

export default component.exports